import axios from 'axios';
import { useState, useEffect } from 'react';

const ipClient = axios.create({
  baseURL: 'https://client-info.fullforce.workers.dev',
  headers: { Accept: 'application/json' },
  timeout: 8000,
});

export const IP_CACHE = new Map();

export const getIp = async () => {
  try {
    const cachedIp = IP_CACHE.get('ip');
    if (cachedIp) return cachedIp;

    const res = await ipClient.get('/');

    if (!res || !res.data) throw new Error('Failed to fetch client info');

    const country = res.data['ff-client-country'] || res.data.country;

    IP_CACHE.set('ip', country);
    return country;
  } catch (error) {
    console.error('Failed to fetch client info', error);
    return null;
  }
};

function useGetIp() {
  const [data, setData] = useState(IP_CACHE.get('ip') || null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIpData = async () => {
      try {
        setIsLoading(true);
        const res = await getIp();
        setData(res);
        setError(null);
      } catch (err) {
        setError(err.message);
        setData(null);
      } finally {
        setIsLoading(false);
      }
    };
    fetchIpData();
  }, []);

  return {
    data,
    isLoading,
    error,
  };
}

export default useGetIp;
